import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { emailsEqual } from "../utils/emailCompare";
import * as adminsApi from "../api/admins";

const PermissionContext = createContext({ permissions: [], loading: true, reload: () => {} });

export const PermissionProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth0();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPermissions = async () => {
    setLoading(true);
    try {
      const res = await adminsApi.getPermissions();
      setPermissions(res.data.permissions || []);
    } catch (err) {
      console.error("Failed loading permissions:", err);
      setPermissions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      loadPermissions();
    } else {
      setPermissions([]);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.email]);

  return (
    <PermissionContext.Provider value={{ permissions, loading, reload: loadPermissions }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);

export const useViewPermission = (permissionName) => {
  const { permissions, loading } = usePermissions();
  const { user } = useAuth0();

  const isSuperAdmin = emailsEqual(
    user?.email,
    process.env.REACT_APP_SUPER_USER_EMAIL,
  );

  const hasPermission =
    isSuperAdmin ||
    (Array.isArray(permissions) && permissions.includes(permissionName));

  return { hasPermission, loading };
};

export default PermissionContext;
